// 知识库分类
<template>
  <div id="containt">
    <el-tabs v-model="activeName" class="tab-box">
      <el-tab-pane label="列表" name="second">
        <div class="grid-height" style="height: calc(100vh - -35px);">

          <vxe-button @click="insertEvent" v-if="basKnowledgeTypeAdd" status="primary" class="btn2" icon="el-icon-plus">新增</vxe-button>
          <div class="fr">
            <el-button type="warning" class="button-sty" icon="el-icon-search" @click="searchEvent">搜索</el-button>
          </div>


          <div class="input_main">
            <div class="main">
              <el-form class="screen-box" title-width="92px" title-align="right" :data="formData"
              @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
                <div class="main_item">
                  <el-form-item>
                    <div class="item_items">
                      <span>名称:</span>
                      <el-input v-model="title" placeholder=""></el-input>
                    </div>
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </div>
          <vxe-table
            :header-cell-style="{height: '36px',  background: '#f6faff', padding: '0', borderTop: '1px solid #eaeaea', fontSize: '12px', color: '#808080', width: '95%' }"
            :row-config="{height: 36,padding: 0,isHover: true,}"
            :row-style="{ fontSize: '12px',  }"
            :stripe="true"
            resizable
            show-overflow
            keep-source
            ref="xTable"
            row-id="id"
            :edit-rules="validRules"
            :print-config="{}"
            :export-config="{}"
            :loading="loading"
            :tree-config="{transform: true, rowField: 'id', parentField: 'parentId'}"
            :edit-config="{trigger: 'manua', mode: 'row', showStatus: true, autoClear: false}"
            :data="tableData"
          >
            <vxe-column type="checkbox" width="100" tree-node></vxe-column>
            <vxe-column field="typeName" title="名称" :edit-render="{}">
              <template #edit="scope">
                <vxe-input v-model="scope.row.typeName" @blur="validEvent" @change="$refs.xTable.updateStatus(scope)"
                           type="text"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column field="seq" title="排序" :edit-render="{}">
              <template #edit="scope">
                <vxe-input v-model="scope.row.seq" type="integer" min="0" max="10" clearable></vxe-input>
              </template>
            </vxe-column>
            <vxe-column field="stat" title="状态"
                        :edit-render="{name: 'select', options:[{ value:1, label:'启用' }, { value:0, label:'禁用' }]}">
              <template #edit="scope">
                <vxe-select v-model="scope.row.stat">
                  <vxe-option :value="1" label="启用">启用</vxe-option>
                  <vxe-option :value="0" label="禁用">禁用</vxe-option>
                </vxe-select>
              </template>
            </vxe-column>

            <vxe-column title="操作" width="500">
              <template #default="{ row }">
                <vxe-button type="text" status="primary" @click="insertRow(row, 'top')"><i
                  class="el-icon-circle-plus-outline"></i></vxe-button>
                <vxe-button v-if="$refs.xTable.isActiveByRow(row)" type="text" status="primary" @click="addRow(row)"><i
                  class="el-icon-circle-check"> </i></vxe-button>
                <vxe-button v-if="$refs.xTable.isActiveByRow(row)&&!row.isNew" type="text" status="primary"
                            @click="closeEdit(row)"><i class="el-icon-circle-close"></i></vxe-button>
                <vxe-button v-if="$refs.xTable.isActiveByRow(row)&&row.isNew" type="text" status="primary"
                            @click="removeRow(row)"><i class="el-icon-circle-close"></i></vxe-button>
                <vxe-button v-if="!$refs.xTable.isActiveByRow(row)" type="text" status="primary"
                            @click="updateRowEvent(row)"><i class="el-icon-edit"></i></vxe-button>
              </template>
            </vxe-column>
          </vxe-table>

        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import editView from './edit.vue';
import {initVxeTable} from '@/const/crud/admin/table';
import pager from '@/components/pager/index.vue'

import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import api from "@/api/projectApi";
import { mapGetters } from 'vuex';

export default {
  name: 'classification',

  inject: ['reload'],
  components: {editView, pager},
  data() {
    return {
      flag: false,  // 插入标识，确保一次只能插入一条数据
      loading: false,
      tableData: [],
      validRules: {
        typeName: [
          {required: true, message: '名称不能为空'},
          {min: 1, max: 20, message: '名称长度在 1 到 20 个字符'}
        ],
        seq: [
          {required: true, message: '排序不能为空'},
        ]
      },
      title: null,


      total: 0,
      activeName: 'second',
      dataId: 0,
      pageSizes: [10, 20, 100],
      gridData: {},
      showEdit: false,
      editViewDataUpdateFlag: false,
      vxeOption: {},
      searchProjectCode: '',
      searchProjectName: '',
      // 查询参数
      formData: {
        searchCount: false,  // 是否分页
        current: 1,  // 当前页面
        size: 0,  // 页面数据量
        projectCode: '',
        projectName: ''
      },
    };
  },
  mounted() {
    this.findList();
  },
  watch: {
    total(newVal) {
      this.$refs.pager.tableDataTotal = newVal
    },
    activeName(newVal) {
      if (newVal === 'second' && this.editViewDataUpdateFlag) {
        this.initTableList()
      }
    }
  },
  computed:{
    ...mapGetters(["permissions"])
  },
  created(){
    this.basKnowledgeTypeAdd = this.permissions["basKnowledgeTypeAdd"];
  },
  methods: {
    toFilterData() {
            this.searchEvent();
     },
    // 关闭编辑状态
    closeEdit(row) {
      const $grid = this.$refs.xTable
      $grid.clearActived().then(() => {
        this.$http({
          url: api.basKnowledgeType.getDataUrl,
          method: 'post',
          data: {id: row.id}
        }).then(res => {
          let data = res.data.data;
          row.typeName = data.typeName
          row.seq = data.seq
          row.stat = data.stat
          this.flag = false
        })
      })
    },

    // 开启编辑
    updateRowEvent(row) {
      console.log(row, '开启编辑')
      const $grid = this.$refs.xTable
      $grid.setActiveRow(row)
      this.flag = true
    },

    // 更新到后端
    async removeRow(row) {
      const $table = this.$refs.xTable
      await $table.remove(row)
      this.flag = false
    },

    // 添加到后端
    async addRow(row) {
      const $table = this.$refs.xTable
      const errMap = await $table.validate().catch(errMap => errMap)
      if (errMap) {
        VXETable.modal.message({status: 'error', content: '校验不通过！保存失败'})
      } else {
        this.$http({
          url: row.isNew ? api.basKnowledgeType.addDataUrl : api.basKnowledgeType.updateDataUrl,
          method: 'post',
          data: row
        }).then(res => {
          row.id = res.data.data
          row.isNew = false
          const $grid = this.$refs.xTable
          $grid.clearActived().then(() => {
            VXETable.modal.message({status: 'success', content: '保存成功'})
            this.flag = false
            this.reload()  // 存在显示bug，新增显示缩进消失，只能刷新
          })
        }).catch(e => {
          VXETable.modal.message({status: 'error', content: '保存失败'})
          console.error(e)
        })

      }
    },


    findList() {
      this.loading = true
      return new Promise(resolve => {
        this.$http({
          url: api.basKnowledgeType.getListDataUrl,
          data: {title: this.title},
          method: 'post'
        }).then(res => {
          this.tableData = res.data.data
          this.loading = false
          resolve()
        })

      })
    },

    // 顶级类型新增
    insertEvent() {
      if (this.flag) {
        this.$message.warning('请先完成当前正在进行的编辑或新增操作')
        return
      }
      const $table = this.$refs.xTable
      if (!this.flag) {
        const newRow = {
          id: 0,
          parentId: null,
          seq: 0,
          stat: 1,
          isNew: true
        }
        $table.insert(newRow).then(({row}) => $table.setActiveRow(row))
      }
      this.flag = true
    },

    // 表格插入
    async insertRow(currRow, locat) {
      if (this.flag) {
        this.$message.warning('请先完成当前正在进行的编辑或新增操作')
        return
      }
      const $table = this.$refs.xTable
      // 如果 null 则插入到目标节点顶部
      // 如果 -1 则插入到目标节点底部
      // 如果 row 则有插入到效的目标节点该行的位置
      if (locat === 'top') {
        const record = {
          name: '新数据',
          id: Date.now(),
          parentId: currRow.id, // 需要指定父节点，自动插入该节点中
          stat: 1,
          isNew: true,
          seq: 0
        }
        const {row: newRow} = await $table.insert(record)
        await $table.setTreeExpand(currRow, true) // 将父节点展开
        await $table.setActiveRow(newRow) // 插入子节点
        this.flag = true
      }
    },


    // 刷新
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },


    // 搜索
    searchEvent() {
      this.findList()
    },

    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },
    editViewDataUpdate() {
      this.editViewDataUpdateFlag = true;
    },
    initTableList() {
      let that = this;
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: '/basic/basRecallProject/getListPage',
        param: this.formData,
        method: 'post',
        height: '800px',
        columns: [
          {type: 'seq', width: 60, title: '序号', resizable: false, fixed: 'left'},
          {
            title: '分类名称',
            field: 'projectName',
            width: 150,
            fixed: 'left'
          },
          {
            title: '上级分类',
            field: 'projectCode',
            width: 150,
          },
          {
            title: '启用',
            field: 'usable',
            width: 150,
            slots: {
              default: ({row}) => {
                if (row.usable == 0) {
                  return [
                    <div class="txt-status disable">
                      <span>禁用</span>
                    </div>
                  ];
                } else if (row.usable == 1) {
                  return [
                    <div class="txt-status">
                      <span>启用</span>
                    </div>
                  ];
                }
              }
            }
          },
          {
            field: 'createTime',
            title: '创建时间',
            width: 150
          },
          {
            title: '创建人',
            field: 'createBy',
            width: 150,

          },
          {
            width: 47,
            fixed: 'right',
            title: '',
            sortable: false,
            slots: {
              default: ({row}) => {
                return [
                  <div>
                    <a
                      href="javascript:void(0);"
                      class="a-link"
                      onclick={() => {
                        this.openEditDialog(row.id);
                      }}
                    >
                      <el-tooltip enterable={false} effect="dark" content="查看" placement="top"
                                  popper-class="tooltip-skin">
                        <i class="el-icon-edit"/>
                      </el-tooltip>
                    </a>
                  </div>
                ];
              }
            }
          }
        ]
      };
      // initVxeTable(tableOption).then(opts => {
      this.vxeOption = initVxeTable(tableOption);
      this.editViewDataUpdateFlag = false;
      this.flushed()
    },
  }
};
</script>
<style lang="scss" scoped>
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.btn2 {
  border-color: #00c4b3 !important;
  background-color: #00c4b3 !important;
  color: #fff !important;
  width: 96px !important;
  height: 28px !important;
  font-size: 12px !important;
  line-height: 25px !important;
  border-radius: 2px !important;
  padding: 0 12px !important;
}

::v-deep .vxe-toolbar {
  font-size: 14px;
  height: 0px !important;
}

// >>> .vxe-table--render-default .vxe-body--row.row--hover, .vxe-table--render-default .vxe-body--row.row--hover.row--stripe {
//     background-color: #024bba!important;
// }
.input_main {
  margin-top: 5px;

  .main {
    display: flex;
    flex-direction: column;
    background-color: #fff;

    .main_item {

      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      background-color: #F4F6FA;
      padding-top: 4px;
      margin: 0px 0px 5px 0px;
      border-top: solid 1px #E9E9E9;
      border-bottom: solid 1px #E9E9E9;

      .item_items {
        display: flex;
        margin-bottom: 4px;

        span {
          width: 75px;
          font-weight: 400;
          text-align: right;
          line-height: 28px;
          font-size: 12px;
          position: relative;
          padding: 0 10px 0 4px;
          color: rgba(86, 86, 86, 0.96);
        }

        .el-input {
          width: 60%
        }
      }
    }
  }

}

::v-deep .el-form-item {
  margin-bottom: -3px !important;
}

.vxe-input--inner {
  height: 80% !important;
  margin-top: 3px !important;
}
::v-deep .vxe-loading{
  background-color: rgba(255, 255, 255,.2)!important
}
</style>
